import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Context } from "../../../../Store";
import { refreshProgramList } from "../../../../Store/ProgramsList/actions";
import callAPI from "../../../../api/apiCaller";
import Loading from "../../../../common/Loading";
import Tabs from "../../../../common/Tabs";
import { ButtonContainer } from "../../Header/Notifications/styles";
import AddProgram from "../popups/AddProgram";
import ProgramHome from "./ProgramHome";
import { programContentConfig } from "./config";
import {
  ProgramContentContainer,
  TabsContainer,
  HamburgerIconContainerSpan,
  HamburgerIconContainer,
  NoProgramContainer,
  ProgramTabContainer,
} from "./styles";
import Requests from "./ProgramRequests";

function ProgramContent(props) {
  let params = useParams();
  let navigate = useNavigate();
  const [program, setProgram] = React.useState(null);
  const { state, dispatch } = React.useContext(Context);
  const [showAddProgram, setShowAddProgram] = React.useState(false);
  const [meetingRequestCount, setMeetingRequestCount] = React.useState(0);

  React.useEffect(() => {
    retrieveProgramInformation();
    retrieveProgramMeetingCount();
  }, [params.selectedProgram]);

  function retrieveProgramInformation() {
    setProgram(null);
    params.selectedProgram &&
      callAPI(dispatch, "getProgramInformation", {
        id: params.selectedProgram,
      }).then((info) => {
        setProgram(info.data);
      });
  }

  function retrieveProgramMeetingCount() {
    params.selectedProgram &&
      callAPI(dispatch, "getOpenNetworkRequest", {
        id: params.selectedProgram,
      }).then((info) => {
        setMeetingRequestCount(info?.data?.length);
      });
  }

  if (params.selectedProgram === undefined) {
    return (
      <ProgramContentContainer hamburgerOpen={props.hamburgerOpen}>
        <Requests />
        <NoProgramContainer meetingMode={true}>
          <HamburgerIconContainer
            onClick={() => props.setHamburgerOpen(!props.hamburgerOpen)}
          >
            <HamburgerIconContainerSpan></HamburgerIconContainerSpan>
            <HamburgerIconContainerSpan></HamburgerIconContainerSpan>
            <HamburgerIconContainerSpan></HamburgerIconContainerSpan>
          </HamburgerIconContainer>
        </NoProgramContainer>
        <ButtonContainer>
          {showAddProgram && (
            <AddProgram
              closeModal={(shouldRefresh) => {
                if (shouldRefresh) {
                  dispatch(refreshProgramList());
                }
                setShowAddProgram(false);
              }}
            />
          )}
        </ButtonContainer>
      </ProgramContentContainer>
    );
  } else if (program === null) {
    return <Loading loadingItem="Program" />;
  } else if (program.enrollment && program.enrollment != "active") {
    return (
      <ProgramContentContainer hamburgerOpen={props.hamburgerOpen}>
        <ProgramHome program={program} />
      </ProgramContentContainer>
    );
  }
  // Self service has all Mentors tab.
  // Program manager has different tabs
  else {
    // let options = programContentConfig[program.type][program.role];
    let options = programContentConfig[program.programType][program.role];

    let CurrentComponent =
      options &&
      options.find((option) => option?.value === params?.tab)?.component;
    return (
      <ProgramContentContainer hamburgerOpen={props.hamburgerOpen}>
        <TabsContainer>
          <HamburgerIconContainer
            onClick={() => props.setHamburgerOpen(!props.hamburgerOpen)}
            isProgram={true}
          >
            <HamburgerIconContainerSpan></HamburgerIconContainerSpan>
            <HamburgerIconContainerSpan></HamburgerIconContainerSpan>
            <HamburgerIconContainerSpan></HamburgerIconContainerSpan>
          </HamburgerIconContainer>
          <ProgramTabContainer>
            <Tabs
              value={params.tab}
              setValue={(newTab) => {
                navigate("/programs/" + params.selectedProgram + "/" + newTab);
              }}
              options={options}
              isWidth={true}
              count={meetingRequestCount === 0 ? false : meetingRequestCount}
            />
          </ProgramTabContainer>
        </TabsContainer>
        <CurrentComponent
          program={program}
          refreshProgram={retrieveProgramInformation}
        />
      </ProgramContentContainer>
    );
  }
}
export default ProgramContent;
